export default {
  heading: "登入资讯",
  accountSelect:{
    heading:"请选择您想要变更的登入资讯",
    cityId:"校本帐户",
    email:"会员帐户",
  },  
  thirdPartyAccount:{
    heading: "将第三方帐户与教城帐户连系",
    description: "您可以使用以下第三方帐户登入教城网站。",
    connectInstruction: "请点击以下图示以连系 / 取消连系。",
    connectReminder: "彩色图标表示已关联到您的 EdCity 帐户。黑色图标表示未关联到您的 EdCity 帐户。", 
    oauthCallback:{
      success: "第三方帐户已成功连繫",
      identifierUsed: "第三方帐户连繫失败，你登入的第三方帐户已经连繫到另一个教城帐户。",
      userIdUsed: "第三方帐户连系失败，你登入的教城帐户已经连系到另一个第三方帐户。",
      unknown: "第三方帐户连繫失败，请稍后再试。",
      closeBtn: "关闭",      
      autoCloseMessagePre: "此视窗将在 ",
      autoCloseMessagePost: " 秒后自动关闭。"
    }  
  },
};
